import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateTestimonial from "../../components/Settings/Testimonial/UpdateTestimonial";

export const UpdateTestimonialPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateTestimonial />
        </div>
      </div>
    </div>
  );
};
